// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const card: Styleguide["card"] = {
    sizes: {
        xsmall: {
            css: css`
                padding: 0.5rem;
                border-radius: 0.25rem;
            `,
        },
        small: {
            css: css`
                padding: 0.75rem;
                border-radius: 0.25rem;
            `,
        },
        medium: {
            css: css`
                padding: 1rem;
                border-radius: 0.375rem;
            `,
        },
        large: {
            css: css`
                padding: 1.5rem;
                border-radius: 0.75rem;
            `,
        },
    },

    variants: {
        outlined: {
            wrapper: {
                css: css`
                    ${({ theme }) => `
                    border: 1px solid ${theme.colors.common.border};
                    `};
                `,
            },
        },
        filled: {
            wrapper: {
                css: css`
                    ${({ theme }) => `
                    background-color: ${theme.colors.common.checkboxPickerBackground};
                    color: ${getColor("primary")}
                `};
                `,
            },
        },
        unstyled: {
            wrapper: {
                css: css`
                    box-shadow: none;
                    border-radius: 0;
                `,
            },
        },
        elevated: {
            wrapper: {
                css: css`
                    ${({ theme }) => `                                      
                    box-shadow: ${theme.shadows[3]};   
            `}
                `,
            },
        },
    },
};

export default card;
